import { RootState } from 'app/store';
import { selectConfigSavePending } from 'features/configurations';
import { selectStructureSavePending } from 'features/structure';

export const selectAutosavePending = (state: RootState): boolean =>
  selectConfigSavePending(state) || selectStructureSavePending(state);
